var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutocompleteSelect',{attrs:{"props":_vm.props},on:{"update":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }